var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 12 20q0-.424.287-.712A.97.97 0 0 1 13 19h6V5h-6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 4q0-.424.287-.712A.97.97 0 0 1 13 3h6q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm-1.825-8H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 12q0-.424.288-.713A.97.97 0 0 1 4 11h7.175L9.3 9.125a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.312.95.95 0 0 1 .725.287L14.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575a.93.93 0 0 1-.713.288 1.02 1.02 0 0 1-.712-.313.97.97 0 0 1-.263-.713.98.98 0 0 1 .288-.687z"
  }))));
};
export default SvgLogin;